import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { DownOutlined, CloseCircleFilled } from '@ant-design/icons';

type FilterDropdownOption = {
   name: string;
   value?: string | number;
   teamId?: string | number;
   id?: string | number;
};

type FilterDropdownProps = {
   options?: FilterDropdownOption[];
   selectedOption?: FilterDropdownOption | null;
   placeholder: string;
   minWidth?: string;
   onSelect: (option: FilterDropdownOption) => void;
   onClear?: (e: React.MouseEvent<HTMLElement>) => void;
   dropDownStyle: (value: FilterDropdownOption | null | undefined) => string;
   placement?:
      | 'bottomLeft'
      | 'bottomCenter'
      | 'bottomRight'
      | 'topLeft'
      | 'topCenter'
      | 'topRight';
};

const FilterDropdown: React.FC<FilterDropdownProps> = ({
   options = [],
   selectedOption = null,
   placeholder,
   minWidth = '200px',
   onSelect,
   onClear,
   dropDownStyle,
   placement = 'bottomRight',
}) => {
   return (
      <Dropdown
         overlay={
            <Menu>
               {options.map((option) => (
                  <Menu.Item
                     key={option.value ?? option.teamId ?? option.id}
                     onClick={() => onSelect(option)}
                  >
                     {option.name}
                  </Menu.Item>
               ))}
            </Menu>
         }
         placement={placement}
         trigger={['click']}
      >
         <Button
            className="dropdown-btn-dash d-flex flex-row justify-content-between align-items-center"
            style={{
               minWidth,
               color: dropDownStyle(selectedOption),
            }}
         >
            <span>
               {selectedOption ? selectedOption.name : placeholder}
            </span>

            <span className="d-flex align-items-center gap-2">
               {selectedOption ? (
                  <CloseCircleFilled
                     onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onClear?.(e);
                     }}
                     style={{ color: '#adb5bd', fontSize: '14px' }}
                     rev={undefined}
                  />
               ) : (
                  <DownOutlined
                     style={{ marginLeft: '10px' }}
                     rev={undefined}
                  />
               )}
            </span>
         </Button>
      </Dropdown>
   );
};

export default FilterDropdown;